import { render, staticRenderFns } from "./DistributorRank.vue?vue&type=template&id=bb64ee42&scoped=true&"
import script from "./DistributorRank.vue?vue&type=script&lang=js&"
export * from "./DistributorRank.vue?vue&type=script&lang=js&"
import style0 from "./DistributorRank.vue?vue&type=style&index=0&id=bb64ee42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb64ee42",
  null
  
)

export default component.exports